import React from 'react'
import {useSelector} from 'react-redux'
import {reduxForm, Field} from 'redux-form'
import Modal, {withModal} from 'jbc-front/components/CommonModal'
import {Error} from 'jbc-front/components/Form'
import Button from 'jbc-front/components/Button'
import {Download} from 'jbc-front/components/icons'
import {required} from 'jbc-front/utils/validators'
import styles from 'tm/notifications/CsvDownload.scss'
import {asyncError} from 'store/actions/asyncError'
import downloadFile from 'tm/downloadFile'
import {omit} from 'lodash'
import {flow} from 'lodash/fp'

const formName = 'csv_download'

const downloadOptions = [
  {value: 'UTF-8', label: 'UTF-8（推奨）'},
  {value: 'Windows-31J', label: 'Shift-JIS'},
]

const renderRadioField = ({label, input, options, disabled, note, radioNote, meta}) => (
  <div className={meta.error && meta.touched ? styles.invalidField : styles.field}>
    <div className={styles.label}>{label}</div>
    <div className={styles.note}>{note}</div>
    <div>
      {options.map(({label, value}) => (
        <div style={{display: 'inline-block'}} className="input-label" key={value}>
          <label>
            <input
              {...omit(input, 'value')}
              type="radio"
              value={value}
              checked={value == input.value}
              disabled={disabled}
              className={`m-radio-input${disabled ? ' disabled' : ''}`}
            />
            <span className={`m-radio-parts${disabled ? ' disabled' : ''}`}>{label}</span>
          </label>
        </div>
      ))}
    </div>
    {radioNote && <div className={styles.note}>{radioNote}</div>}
    <Error meta={meta} label={label} />
  </div>
)

const Form = flow(
  reduxForm({
    form: formName,
    enableReinitialize: true,
  })
)(({handleSubmit, submitting, hideModal = []}) => {
  return (
    <React.Fragment>
      <Modal.Header hideModal={hideModal}>回答のダウンロード</Modal.Header>
      <Modal.Body className={styles.modalbody}>
        <form onSubmit={handleSubmit}>
          <Field
            component={renderRadioField}
            label="ファイル形式選択"
            name="encoding"
            options={downloadOptions}
            radioNote="Excel2016より前のバージョンのExcelをお使いの方はShift-JISをご利用ください。"
            validate={required}
          />
          <br />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Buttons>
          <Button onClick={hideModal}>キャンセル</Button>
          <Button primary onClick={handleSubmit} disabled={submitting}>
            <Download />
            ダウンロード
          </Button>
        </Modal.Buttons>
      </Modal.Footer>
    </React.Fragment>
  )
})

const initialValues = {encoding: 'UTF-8'}

const CsvDownload = ({isModalOpen, showModal, hideModal = []}) => {
  const [token, notification] = useSelector((state) => [state.auth.token, state.tm.notifications.current.data])
  return (
    <React.Fragment>
      <Button widthAuto onClick={showModal} className={styles.downloadButton}>
        回答一括ダウンロード
      </Button>
      <Modal isOpen={isModalOpen} hideModal={hideModal}>
        {isModalOpen && (
          <Form
            {...{hideModal, token, notification}}
            initialValues={{...initialValues}}
            onSubmit={async ({...values}, dispatch, {hideModal, token, notification}) => {
              const id = notification.id
              const params = {...values}
              hideModal()
              await downloadFile(
                `/tm/api/notifications/${id}/export_notification_answers_csv`,
                token,
                (err) => dispatch(asyncError(err)),
                params,
                true
              )
            }}
          />
        )}
      </Modal>
    </React.Fragment>
  )
}

export default withModal(CsvDownload)
